import React from "react";

const paths = {
  arrowRight: <path d="M5 12h14m-6-6 6 6-6 6" />,
  translate: (
    <>
      <path d="M5 8h8" />
      <path d="M9 4v4" />
      <path d="M12 20l4-9 4 9" />
      <path d="M14 16h4" />
      <path d="M5 8c1.1 3.2 3 5.5 6 7" />
      <path d="M12 8c-.8 2.4-2.4 4.4-5 6" />
    </>
  ),
  menu: (
    <>
      <path d="M4 7h16" />
      <path d="M4 12h16" />
      <path d="M4 17h16" />
    </>
  ),
  close: (
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6 6 18" />
    </>
  ),
  chart: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="M8 15l3-4 3 2 5-7" />
    </>
  ),
  engineering: (
    <>
      <path d="M14 7l3 3" />
      <path d="M5 19l8.5-8.5" />
      <path d="M13 4l7 7-2 2-7-7z" />
      <path d="M6 5l3 3" />
      <path d="M4 7l3-3" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10" width="14" height="10" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </>
  ),
  router: (
    <>
      <rect x="4" y="11" width="16" height="7" rx="2" />
      <path d="M8 15h.01" />
      <path d="M12 15h.01" />
      <path d="M16 15h.01" />
      <path d="M8 8a6 6 0 0 1 8 0" />
      <path d="M10 6a3 3 0 0 1 4 0" />
    </>
  ),
  sliders: (
    <>
      <path d="M5 7h14" />
      <path d="M5 12h14" />
      <path d="M5 17h14" />
      <path d="M9 5v4" />
      <path d="M15 10v4" />
      <path d="M11 15v4" />
    </>
  ),
  alert: (
    <>
      <path d="M12 4 3.5 19h17z" />
      <path d="M12 9v4" />
      <path d="M12 16h.01" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="m16 16 4 4" />
    </>
  ),
  tree: (
    <>
      <path d="M12 5v14" />
      <path d="M12 8H7v4" />
      <path d="M12 12h5v4" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
      <rect x="4" y="12" width="6" height="4" rx="1" />
      <rect x="14" y="16" width="6" height="4" rx="1" />
    </>
  ),
  check: (
    <>
      <path d="M20 7 10 17l-5-5" />
      <circle cx="12" cy="12" r="9" />
    </>
  ),
  email: (
    <>
      <rect x="4" y="6" width="16" height="12" rx="2" />
      <path d="m4 8 8 6 8-6" />
    </>
  ),
  telegram: (
    <>
      <path d="M21 4 3 11l7 2 2 7z" />
      <path d="M10 13 21 4" />
    </>
  ),
};

const Icon = ({ name, className = "" }) => (
  <svg
    aria-hidden="true"
    className={`icon ${className}`.trim()}
    focusable="false"
    viewBox="0 0 24 24"
  >
    {paths[name]}
  </svg>
);

export default Icon;
